import {
  CREATE_DEAL,
  DEAL_LIST,
  DELETE_DEAL,
  UPDATE_DEAL,
  UPDATE_DEAL_STATUS,
  VIEW_DEAL,
} from "./apiRoutes";
import { authData } from "./Service";

export const createDealApi = async (data) => {
  const response = await authData.post(CREATE_DEAL, data);
  return response?.data;
};
export const listOfDealApi = async (data) => {
  const response = await authData.post(DEAL_LIST, data);
  return response?.data;
};
export const updateDealApi = async (data) => {
  const response = await authData.put(UPDATE_DEAL, data);
  return response?.data;
};
export const viewDeal = async (id) => {
  const response = await authData.get(`${VIEW_DEAL}${id}`);
  return response?.data;
};
export const deleteDeal = async (id) => {
  const response = await authData.delete(`${DELETE_DEAL}${id}`);
  return response?.data;
};
export const updateDealStatusApi = async (data) => {
  const response = await authData.put(UPDATE_DEAL_STATUS, data);
  return response?.data;
};
